import { Doc } from '@dadohr/shared/domainTypes/document';
import { IExperienceDenormalized } from '@dadohr/shared/domainTypes/experience';
import {
  FullstoryUserData,
  useFullstoryIdentify
} from '../../hooks/useFullstoryIdentify';

export const useFullstoryIdentifyForStandaloneApp = (
  d: void | Doc<IExperienceDenormalized>
) => {
  const data: FullstoryUserData | null = d
    ? {
        user: { ...d.data.user, id: d.data.userId },
        org: { ...d.data.org, id: '' } // don't have user id here!
      }
    : null;
  useFullstoryIdentify('standalone-app', data);
};
